/**
 * Select2 Factory
 */
export default class Select2Factory {
    static parametersNew(parameters) {
        let defaults = {
            // scope: 'select.select2',
            options: {
                placeholder: 'Select State',
                // dropdownParent: $('.grey-background'),
                sorter: function (results) {
                    let query = $('.select2-search__field').val().toLowerCase();

                    let sortFunc = (a, b) => {
                        return a.text.localeCompare(b.text);
                    };

                    if (query) {
                        sortFunc = (a, b) => {
                            return a.text.toLowerCase().indexOf(query) <
                                b.text.toLowerCase().indexOf(query)
                                ? -1
                                : 1;
                        };
                    }

                    return results.sort(sortFunc);
                },

                templateSelection: formatState,
                templateResult: formatState,
                escapeMarkup: function(markup) {
                    return markup;
                },
            },
        };

        function formatState (data, container) {
            $(container).attr('data-gtm', $(data.element).attr('data-gtm'));

            if (!data.id) { return data.text; }
            var flags = window.geoFlags;
            return $('<img data-src="' +  flags[data.element.value] + '" class="img-flag lazyload" /><span>' + data.text + '</span>');
        }

        if (typeof parameters !== 'object') {
            return defaults;
        }

        return $.extend({}, true, defaults, parameters);
    }

    static parameters(parameters) {
        let defaults = {
            scope: 'select.select2',
            options: {
                placeholder: 'Select State',
                sorter: function (results) {
                    let query = $('.select2-search__field').val().toLowerCase();

                    let sortFunc = (a, b) => {
                        return a.text.localeCompare(b.text);
                    };

                    if (query) {
                        sortFunc = (a, b) => {
                            return a.text.toLowerCase().indexOf(query) <
                                b.text.toLowerCase().indexOf(query)
                                ? -1
                                : 1;
                        };
                    }

                    return results.sort(sortFunc);
                },
                templateResult: function (data, container) {
                    // Add custom attributes to the <option> tag for the selected option
                    $(container).attr('data-gtm', $(data.element).attr('data-gtm'));
                    return data.text;
                },
            },
        };

        if (typeof parameters !== 'object') {
            return defaults;
        }

        return $.extend({}, true, defaults, parameters);
    }

    static create(parameters) {

        var newStateSelects = $('.state-selector .select2');

        if (newStateSelects.length > 0) {
            $.map( newStateSelects, function( select ) {
                let settings = Select2Factory.parametersNew(parameters);
                settings.options.dropdownParent = $(select).parent('.grey-background');
                $(select).select2(settings.options);
            });

            $('.state-selector').on('select2:select', function (e) {
                $(".update-state").css("display", "block");
            });

            $('.update-state').on('click', function (e) {
                $(this).css("display", "none");
            });

            $(".select2-container--default").on( "click", function() {
                var inputSearch = $(".select2-search__field");
                $(inputSearch).attr("placeholder", "Search");
            });

            $(".oplist-top-bar .blue-text").each(function() {
                $(this).on("click", function () {
                    $('body').addClass("select-state");
                });
            });

            $('body').on('shown.bs.modal', '.modal', function() {
                $(".modal-backdrop, button.close").each(function() {
                    $(this).on("click", function () {
                        $('body').removeClass("select-state");
                        $(".oplist-top-bar .state-selector").modal("hide");
                    });
                });
            });
        } else {
            let settings = Select2Factory.parameters(parameters);

            $(settings.scope).select2(settings.options);
        }
    }
}

global.select2Factory = Select2Factory;

// Calling this function in RegionSelector component as well
setTimeout(function () {
    select2Factory.create();
}, 200);
